import { AxiosResponse } from "axios";

import { res } from "./types";

/*
 * format return type for API success (Status Code: 200) response
 */
export const handleFormatResponse = (response: AxiosResponse<any, any>) => {
  const responseData: AxiosResponse<any> = response ?? res;
  let r = res;
  if (responseData.status == 200) {
    return (r = {
      ...r,
      isSuccess: true,
      data: responseData.data,
      status: responseData.status,
      message: responseData.data.message
        ? String(responseData.data.message)
        : "success",
        error: undefined
    });
  } else {
    return (r = {
      isSuccess: false,
      data: undefined,
      error: responseData.data.response,
      status: responseData.status || 0,
      message: String(responseData.data.message) || "",
    });
  }
};

/*
 * format return type for API request fails
 */
export const handleFormatResponseForError = (error: any) => {
  // console.log("Error: ", error?.response?.status);
  let r = res;
  return (r = {
    isSuccess: false,
    data: undefined,
    error: error,
    status: error?.response?.status,
    message:
      error?.response?.data?.data?.message ||
      error?.response?.data?.data?.detail ||
      error?.message ||
      "Request could not get processed!",
  });
};

export const camelCaseToTitleCase = (input: string): string => {
  // Split the string by uppercase letters
  const words = input.split(/(?=[A-Z])/);

  // Capitalize the first letter of each word and join them back together
  const titleCase = words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  return titleCase;
};

export default function CommaSeparator(value: number) {
  if (!isNaN(value)) {
    const formattedNumber = new Intl.NumberFormat("en-IN").format(value);
    return formattedNumber;
  } else {
    return 0;
  }
}
